export const TitleIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none">
      <rect width="31" height="31" x=".5" y=".5" fill="#fff" rx="15.5" />
      <rect width="31" height="31" x=".5" y=".5" stroke="#CAC8D1" rx="15.5" />
      <path
        fill="#44414E"
        d="M22.22 24.905H9.78a.862.862 0 0 1-.864-.863V7.951c0-.474.382-.863.864-.863h12.44c.474 0 .863.382.863.863V24.05a.862.862 0 0 1-.863.863v-.008Zm-11.577-1.718h10.714V8.814H10.643v14.373Z"
      />
      <path
        fill="#44414E"
        d="M19.546 20.699h-7.103a.862.862 0 0 1-.863-.863c0-.481.382-.863.863-.863h7.103c.473 0 .863.382.863.863a.857.857 0 0 1-.863.863ZM19.546 16.85h-7.103a.862.862 0 0 1-.863-.863c0-.481.382-.863.863-.863h7.103c.473 0 .863.382.863.863a.857.857 0 0 1-.863.863ZM19.546 13.01h-7.103a.862.862 0 0 1-.863-.864c0-.48.382-.863.863-.863h7.103c.473 0 .863.382.863.863a.857.857 0 0 1-.863.863Z"
      />
    </svg>
  )
}
